export default "__VITE_ASSET__DRZoZwN0__"